import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

const Wrapper = styled.div``

const RequireHint = (props) => {
  const { isPickup } = props

  return (
    <Wrapper className="text-muted mx-2 mt-2">
      <strong>Hinweis:</strong> Sie sehen dieses {isPickup ? 'Abholsegment' : 'Zustellsegment'}, da
      Sie {isPickup ? 'unterhalb' : 'oberhalb'} die Option{' '}
      <strong>{isPickup ? 'Abholung' : 'Zustellung'} in eigenem Gebiet</strong> gewählt haben.
    </Wrapper>
  )
}

export default RequireHint
